<template>
    <shop-products-list ref="productsList" @edit="edit($event)"></shop-products-list>
</template>

<script>
    export default {
        methods: {
            showForm() {
                this.addMode = true;
            },

            hideForm() {
                this.addMode = false;
                this.current = null;
            },

            reloadProducts() {
                this.addMode = false;
                this.current = null;
                this.$refs.productsList.getProducts();
            },

            edit(event) {
                this.addMode = true;
                this.current = event;
            }
        }
    }
</script>
